<template>
  <v-text-field
    v-model="inputValue"
    prepend-inner-icon="fa-light fa-search"
    variant="outlined"
    class="search-bar-input"
    :class="{ desktop: !$vuetify.display.xs }"
    :bg-color="bgColor"
    hide-details
    density="comfortable"
    placeholder="Meklēt Somā"
    @keydown.enter="submit"
  >
  </v-text-field>
</template>

<script>
export default {
  props: {
    insideDrawer: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    config: useRuntimeConfig(),
    inputValue: "",
  }),

  computed: {
    bgColor() {
      return this.insideDrawer ? "rgba(0, 0, 0, 0.04)" : "grayBack"
    },
  },

  methods: {
    submit() {
      window.location.href = this.config.public.oldFrontendRoot + `search?query=${this.inputValue}` // SENDS TO SOMA SEARCH RESULT PAGE - TEMPORARY
    },
  },
}
</script>

<style lang="sass">
.search-bar-input
  min-width: 226px
  &.desktop
    max-width: 226px

  .v-field__outline
    --v-field-border-width: 0

  .v-field__prepend-inner .v-icon
    font-size: 20px
</style>
